import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';

import { MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import { Subject, takeUntil } from 'rxjs';
import { AuthService, SignInService } from 'src/app/modules/core/services';
import { LanguageStore } from 'src/app/modules/core/store';
import { User } from 'src/app/modules/shared/models';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    imports: [TranslateModule, MatMenuModule, MatIconModule],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class UserComponent implements OnInit, OnDestroy {
    private _authService = inject(AuthService);
    private _signInService = inject(SignInService);
    private _languageStore = inject(LanguageStore);

    @ViewChild('userMenuTrigger') userMenuTrigger: MatMenuTrigger;

    public user: User;
    public userFullName = '';
    public userIsLoggedIn = false;

    private _ngUnsubscribe$ = new Subject<void>();

    public get languages() {
        return ['sv_se', 'nb_no', 'fi_fi', 'da_dk', 'en_us'];
    }

    public get displayMenu() {
        return 'displayMenu';
    }

    public get isUserMenuOpen() {
        if (this.userMenuTrigger) {
            return this.userMenuTrigger.menuOpen;
        }
    }


    constructor() { }

    ngOnInit() {
        this.user = this._signInService.user;

        this.userIsLoggedIn = this._authService.isOnline();

        this._signInService.user$.pipe(
            takeUntil(this._ngUnsubscribe$)
        ).subscribe(user => {
            this.user = user;
            this.userFullName = this.user?.fullName;
        });
    }

    public languageName(shortLang: string): string {
        switch (shortLang) {
            case 'sv_se':
                return 'Svenska';
            case 'nb_no':
                return 'Norska';
            case 'fi_fi':
                return 'Suomalainen';
            case 'da_dk':
                return 'Dansk';
            case 'en_us':
                return 'English';
            default:
                return shortLang;
        }
    }

    ngOnDestroy() {
        this._ngUnsubscribe$.next();
        this._ngUnsubscribe$.complete();
    }

    public selectLanguage(lang: string) {
        this._languageStore.setLanguage(lang);
    }

    public login() {
        this._authService.login(true);
    }

    public async onLogout() {
        await this._authService.logout();
    }
}
